import Vue from 'vue'
import NFS from './NFS'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import db from 'utils/localstorage'
import VueApexCharts from 'vue-apexcharts'
import VueCookies from 'vue-cookies'
import dataV from '@jiaminghi/data-view'
import waterfall from 'vue-waterfall2'
import VueContextMenu from 'vue-contextmenu'
import vcolorpicker from 'vcolorpicker'

import 'ant-design-vue/dist/antd.css'

import 'utils/install'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(db)
Vue.use(VueApexCharts)
Vue.use(VueCookies)
Vue.use(dataV)
Vue.use(waterfall)
Vue.use(VueContextMenu)
Vue.use(vcolorpicker)

Vue.component('apexchart', VueApexCharts)

Vue.use({
  install (Vue) {
    Vue.prototype.$db = db
  }
})

Vue.prototype.$postFile = request.postFile
Vue.prototype.$post = request.post
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(NFS)
}).$mount('#nfs')



// WEBPACK FOOTER //
// ./src/main.js